import {
  IFormSessionField,
  IFormSessionState,
} from '../reducers/formSessionReducer';
import { FORM_FIELD_TYPE_CODE } from '../../constants/formElements';
import ACTIONS_TYPES from '../../constants/types';
import store from '..';
import {
  ISelectOptions,
  ISelectOptionsDict,
} from '../../utils/interfaces/ISelectOptions';

const mapBackendValuesToInternal = (
  formSessionValues: IFormSessionField[],
): IFormSessionField[] => {
  if (!formSessionValues) {
    return [];
  }
  const formElementsDict = store.getState().formElements;

  const customFieldsIndex = formSessionValues.findIndex(
    (field: IFormSessionField) => field.fieldCode === 'customFields',
  );
  if (customFieldsIndex !== -1) {
    const customFields: IFormSessionField = formSessionValues.splice(
      customFieldsIndex,
      1,
    )[0];
    Object.entries(customFields.value).forEach(([key, value]) =>
      formSessionValues.push({
        fieldCode: key,
        value,
      }),
    );
  }

  return formSessionValues.reduce(
    (acc: IFormSessionField[], field: IFormSessionField) => {
      const { fieldCode, value } = field;
      switch (formElementsDict[fieldCode]) {
        case FORM_FIELD_TYPE_CODE.NATIONALITY_SELECT:
          return [...acc, { fieldCode, value: value?.[0] }];
        default:
          return [...acc, { fieldCode, value }];
      }
    },
    [],
  );
};

interface ISetFormSessionAction {
  type: typeof ACTIONS_TYPES.SET_FORM_SESSION;
  payload: IFormSessionState;
}

interface ISetFormSessionEventsList {
  type: typeof ACTIONS_TYPES.SET_FORM_SESSION_EVENTS_LIST;
  payload: ISelectOptions;
}

interface ISetFormSessionDropdownList {
  type: typeof ACTIONS_TYPES.SET_FORM_SESSION_DROPDOWN_LIST;
  payload: ISelectOptionsDict;
}

interface IResetFormSessionAction {
  type: typeof ACTIONS_TYPES.RESET_FORM_SESSION;
}

interface ISetFormSessionToken {
  type: typeof ACTIONS_TYPES.SET_FORM_SESSION_TOKEN;
  payload: string;
}

const setFormSessionAction = (
  formSession: IFormSessionState,
): ISetFormSessionAction => {
  return {
    type: ACTIONS_TYPES.SET_FORM_SESSION,
    payload: {
      ...formSession,
      fields: mapBackendValuesToInternal(formSession.fields),
    },
  };
};

const setFormSessionToken = (token: string): ISetFormSessionToken => {
  return {
    type: ACTIONS_TYPES.SET_FORM_SESSION_TOKEN,
    payload: token,
  };
};

const setFormSessionEventsList = (
  eventsList: ISelectOptions,
): ISetFormSessionEventsList => {
  return {
    type: ACTIONS_TYPES.SET_FORM_SESSION_EVENTS_LIST,
    payload: eventsList,
  };
};

const setFormSessionDropdownList = (
  dropdownListDict: ISelectOptionsDict,
): ISetFormSessionDropdownList => {
  return {
    type: ACTIONS_TYPES.SET_FORM_SESSION_DROPDOWN_LIST,
    payload: dropdownListDict,
  };
};

const resetFormSession = (): IResetFormSessionAction => {
  return {
    type: ACTIONS_TYPES.RESET_FORM_SESSION,
  };
};

export default {
  setFormSessionAction,
  setFormSessionEventsList,
  resetFormSession,
  setFormSessionDropdownList,
  setFormSessionToken,
};

export type FormSessionActionTypes = ISetFormSessionAction &
  ISetFormSessionEventsList &
  IResetFormSessionAction &
  ISetFormSessionDropdownList;
